<template>
  <div class="account-password-reset-sent">
    <div class="account-password-reset-sent__icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="account-password-reset-sent__check-icon"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
    </div>
    <h3 class="account-password-reset-sent__title">
      {{ t('checkout.passwordResetSent.title') }}
    </h3>
    <p class="account-password-reset-sent__message">
      {{ t('checkout.passwordResetSent.message', { email: email }) }}
    </p>
    <Button class="w-full" @click="handleBack">
      {{ t('checkout.passwordResetSent.backToLogin') }}
    </Button>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

defineProps<{
  email: string
}>()

const emit = defineEmits<{
  (e: 'back'): void
}>()

const handleBack = () => {
  emit('back')
}
</script>

<style lang="postcss" scoped>
.account-password-reset-sent {
  @apply flex flex-col items-center justify-center py-8 px-4 text-center;

  &__icon {
    @apply mb-4;
  }

  &__check-icon {
    @apply text-primary;
    width: 40px;
    height: 40px;
  }

  &__title {
    @apply text-xl font-semibold text-gray-900 mb-2;
  }

  &__message {
    @apply text-base text-gray-600 mb-6 max-w-md;
  }
}
</style>
